export default __webpack_public_path__ + "static/media/ca-3-rMAX.41dbd7c3.avif";